<div *ngIf="loading" class="loading-container">
    <app-small-loading ></app-small-loading>
</div>

<div *ngIf="!loading" class="container">
    <div class="tokens-amount">
        <h1>{{ 'Participation to sell' | translate}}</h1>

        <ng-container *ngIf="asset.saleInfo">
            <p style="font-size: 18px; margin: 1rem 0px 0px 0px">{{ 'Last sale properties setted:' | translate }}</p>
            <div>
                <span style="font-size: 13px;">{{ 'Price: ' | translate}}</span>
                <span style="font-size: 13px;">{{ convertFromWei( asset.saleInfo.price ) }}</span>
            </div>
            <div>
                <span style="font-size: 13px;">{{ 'Participation % for sale: ' | translate }}</span>
                <span style="font-size: 13px;">{{ ( convertFromWei( asset.saleInfo.offer_amount ) * 100 ) / participationTokensMinted  }}%</span>
            </div>
        </ng-container>
    </div>
    <div class="amount-input mt-3">
        <h6>{{ 'Participation percentage to sell' | translate }}</h6>
        <input type="number" [min]="inputMin" [max]="inputMax" [step]="inputMin" [value]="salePercent" (input)="onChangeAmount($event)">
        <span style="font-weight: 700; font-size: 12px">{{ 'Your available participation percentage is:' | translate}} </span>
        <span class="available-tokens">{{ availablePercent }}%</span>
        <p *ngIf="error.status" class="error-message">{{ error.message | translate  }}</p>
        <p *ngIf="salePercent > 0" class="percent">You are going to sell {{ salePercent }}%</p>
    </div>
    <div class="list-for-sale">
        <button class="cancel" (click)="close()">Cancel</button>
        <button *ngIf="!error.status && salePercent > 0 && asset.saleInfo" class="accept" (click)="listForSale()">Update sale </button>
        <button *ngIf="!error.status && salePercent > 0 && !asset.saleInfo" class="accept" (click)="listForSale()">List for sale </button>
    </div>
</div>
